import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import React, { useState, useEffect } from "react";

// Import react-bootstrap components
import { Button } from "react-bootstrap";

import LoginScreen from "./components/LoginScreen";
import ManagerScreen from "./components/ManagerScreen";
import ProviderScreen from "./components/ProviderScreen";
import UserScreen from "./components/UserScreen";

function App() {
  const [isLogin, setIsLogin] = useState(false);
  const [key, setKey] = useState("booking");

  useEffect(() => {
    document.title = "UpHealth Administration";
    if (localStorage.getItem("@uphealth_login_token") !== null) {
      setIsLogin(true);
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("@uphealth_login_token");
    setIsLogin(false);
  };

  // If not logged in, show the full-page login screen
  if (!isLogin) {
    return <LoginScreen setIsLogin={setIsLogin} />;
  }

  // If logged in, show the dashboard
  return (
    <div className="admin-layout">
      {/* Sidebar Navigation */}
      <div className="sidebar">
        <div className="sidebar-brand">
          <img
            src={require("./assets/icon-uphealth.png")}
            alt="UpHealth logo"
          />
          UpHealth Admin
        </div>
        <div className="sidebar-nav">
          <div
            className={`nav-item ${key === "booking" ? "active" : ""}`}
            onClick={() => setKey("booking")}
          >
            <i className="bi bi-calendar-check"></i> Bookings
          </div>
          <div
            className={`nav-item ${key === "provider" ? "active" : ""}`}
            onClick={() => setKey("provider")}
          >
            <i className="bi bi-person-badge"></i> Providers
          </div>
          <div
            className={`nav-item ${key === "user" ? "active" : ""}`}
            onClick={() => setKey("user")}
          >
            <i className="bi bi-people"></i> Users
          </div>
        </div>
        <div className="sidebar-footer mt-auto">
          <Button variant="secondary" className="w-100" onClick={handleLogout}>
            <i className="bi bi-box-arrow-right me-2"></i> Logout
          </Button>
        </div>
      </div>

      {/* Main Content Area */}
      <div className="main-content">
        <div className="top-header">
          <h2 className="mb-0">
            {key === "booking" && "Booking Management"}
            {key === "provider" && "Provider Management"}
            {key === "user" && "User Management"}
          </h2>
          <div className="user-profile d-flex align-items-center gap-3">
            <div className="text-end">
              <div className="fw-bold text-dark">Administrator</div>
              <div className="text-muted small">admin@uphealth.com</div>
            </div>
            <div 
              className="rounded-circle bg-secondary d-flex justify-content-center align-items-center text-white fw-bold"
              style={{ width: "48px", height: "48px" }}
            >
              AD
            </div>
          </div>
        </div>
        <div className="content-area">
          {key === "booking" && <ManagerScreen />}
          {key === "provider" && <ProviderScreen />}
          {key === "user" && <UserScreen />}
        </div>
      </div>
    </div>
  );
}

export default App;
